module.exports = __webpack_public_path__ + "img/entertainment.b3aaa822.svg";